import { useTranslation } from "react-i18next";

/**
 * Compact FR/EN language toggle placed at the top of the sidebar.
 * Persists the choice via i18next-browser-languagedetector (localStorage key: kempf.lang).
 */
export const LanguageToggle = () => {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith("en") ? "en" : "fr";

  const setLang = (lng) => {
    if (lng === current) return;
    i18n.changeLanguage(lng);
    try {
      localStorage.setItem("kempf.lang", lng);
    } catch {}
  };

  return (
    <div
      className="inline-flex items-center gap-0 border border-border rounded-sm overflow-hidden text-[10px] tracking-widest uppercase"
      data-testid="language-toggle"
      role="group"
      aria-label="Language selector"
    >
      <button
        type="button"
        onClick={() => setLang("fr")}
        aria-pressed={current === "fr"}
        data-testid="lang-fr"
        className={`px-2.5 py-1 transition-colors ${
          current === "fr"
            ? "bg-primary text-primary-foreground"
            : "bg-transparent text-muted-foreground hover:text-foreground"
        }`}
      >
        FR
      </button>
      <button
        type="button"
        onClick={() => setLang("en")}
        aria-pressed={current === "en"}
        data-testid="lang-en"
        className={`px-2.5 py-1 transition-colors ${
          current === "en"
            ? "bg-primary text-primary-foreground"
            : "bg-transparent text-muted-foreground hover:text-foreground"
        }`}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageToggle;
